import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Select,
  Tabs,
  Upload,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import Currentprescriptions from "./Tabs/Currentprescriptions";
import Pastprescriptions from "./Tabs/Pastprescriptions";
import CardCurrentPrescription from "../../../components/CardCurrentPrescription";
import PopUp from "./PopUp/PopUp";
import { useLocation, useNavigate } from "react-router-dom";
import { useBasePath } from "../../../components/NavigatePath";
import dayjs from "dayjs";
import axios from "axios";
import { useSelector } from "react-redux";
import UploadProfilePicture from "../../../components/UploadProfilePicture";

function ViewProfile() {
  const hasRedirected = useRef(false);
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const [activeKey, setActiveKey] = useState("Currentprescriptions");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const location = useLocation();
  const data = location.state?.data;
  const navigate = useNavigate();
  const basePath = useBasePath();
  const API_URL = import.meta.env.VITE_API_URL;
  const accessToken = useSelector((state) => state.user.accessToken);
  const [FlagFetch, setFlagFetch] = useState(0);
  const [imageUrl, setImageUrl] = useState();
  const [pharmacyList, setPharmacyList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [branchId, setBranchId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [originalData, setOriginalData] = useState({});
  const [localUserDetails, setLocalUserDetails] = useState(data ? data.userDetails : null);
  useEffect(() => { }, [FlagFetch, setFlagFetch]);
  useEffect(() => {
    fetchPharmacies();
  }, []);
  useEffect(() => {
    if (pharmacyList.length > 0 && data?.PharmaciesBranches?.length > 0) {
      const initialPharmacy = data.PharmaciesBranches[0].PharmacyDetails;
      const initialBranch = data.PharmaciesBranches[0];

      const selectedPharmacy = pharmacyList.find(
        (ph) => ph.id === initialPharmacy.id
      );
      if (selectedPharmacy) {
        const branches = selectedPharmacy.BranchesDetails;
        setBranchList(branches);
        form.setFieldsValue({
          pharmacy: initialPharmacy.id,
          branch: initialBranch.id,
        });
      }
    }
  }, [pharmacyList, data, form]);
  useEffect(() => {
    if (data === undefined && !hasRedirected.current) {
      if (!hasRedirected.current) {
        message.info("You don't have access to change the URL directly");
        hasRedirected.current = true;
        navigate(-1);
      }
      return;
    }


    setImageUrl(data.userDetails?.profilePicture || "");
  }, [data, basePath, navigate]);

  useEffect(() => {
    setLocalUserDetails(data ? data.userDetails : null);
  }, [data]);

  const fetchPharmacies = async () => {
    try {
      const pharmacyResponse = await axios.get(
        `${API_URL}pharmacies/get-pharmacies?limit=1000`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const activePharmacies = pharmacyResponse.data.Pharmacies.filter(
        (pharmacy) => pharmacy.active
      ).map((pharmacy) => ({
        ...pharmacy,
        BranchesDetails:
          pharmacy.BranchesDetails?.filter((branch) => branch.active) || [],
      }));

      setPharmacyList(activePharmacies);
    } catch (error) {
      console.error("Error fetching pharmacies:", error);
    }
  };
  const tabList = [
    {
      key: "Currentprescriptions",
      label: (
        <p style={{ fontSize: "20px", fontWeight: "500" }}>
          Current Prescriptions
        </p>
      ),
      children: (
        <Currentprescriptions patientId={data ? data.id : null} FlagFetchMain={FlagFetch} />
      ),
    },
    {
      key: "Pastprescriptions",
      label: (
        <p style={{ fontSize: "20px", fontWeight: "500" }}>
          Past Prescriptions
        </p>
      ),
      children: (
        <Pastprescriptions patientId={data ? data.id : null} FlagFetchMain={FlagFetch} />
      ),
    },
    {
      key: "Add",
      label: <img src="/assets/images/add.svg" />,
    },
  ];
  const handleTabChange = (key) => {
    if (key === "Add") {
      setIsModalVisible(true);
      return;
    }

    setActiveKey(key);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false); // Close the modal
  };
  const handlePharmacyChange = async (value) => {
    setBranchList([]);
    setBranchId(null);
    form.setFieldsValue({ branch: undefined });
    let pharmacyID = pharmacyList.find((ph) => ph.id === value);

    try {
      let responseBranches;
      if (pharmacyID) {
        responseBranches = await axios.get(
          `${API_URL}pharmacies?id=${pharmacyID.id}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        let pharmacyData = responseBranches.data.Pharmacy;
        if (!pharmacyData.active) {
          setBranchList([]);
          return;
        }

        const activeBranches = pharmacyData.BranchesDetails.filter(
          (branch) => branch.active
        );

        setBranchList(activeBranches);
      } else {
        setBranchList([]);
      }
      setBranchId(null);
      form.setFieldsValue({ branch: undefined });
    } catch (error) {
      console.error("Error fetching branches:", error);
      message.error("Failed to load branch data.");
    }
  };

  // data props
  const userDetails = data ? data.userDetails : null;
  const handleEditClick = () => {
    setIsEditing(true); // Enable editing mode
    setOriginalData(form.getFieldsValue()); // Store initial form values
  };

  // Handle the "Save" button click
  const handleSaveClick = async () => {
    const formValues = form.getFieldsValue();
    const changedData = {};
    let hasWhitespaceOnly = false;

    // Convert the dob if it exists and is a dayjs object
    if (formValues.dob && dayjs.isDayjs(formValues.dob)) {
      formValues.dob = formValues.dob.format('YYYY-MM-DD');
    }

    Object.keys(formValues).forEach((key) => {
      const trimmedValue =
        typeof formValues[key] === "string"
          ? formValues[key].trim()
          : formValues[key];

      if (trimmedValue !== originalData[key] && trimmedValue !== "") {
        changedData[key] = trimmedValue;
      }

      if (
        typeof formValues[key] === "string" &&
        formValues[key].trim() === ""
      ) {
        hasWhitespaceOnly = true;
      }
    });

    // Special handling for DOB
    if (formValues.dob && (!localUserDetails?.dob || localUserDetails.dob === "null")) {
      changedData.dob = formValues.dob;
    }

    if (hasWhitespaceOnly) {
      message.info("Here some fields have white space.");
      return;
    }

    const branchChanged = formValues.branch !== originalData.branch;
    console.log(originalData.branch);
    try {
      const branchChanged = formValues.branch !== originalData.branch;
      console.log(originalData.branch);

      try {
        if (branchChanged) {
          if (originalData.branch) {
            try {
              await axios.delete(`${API_URL}Branches/deleteOnePatient`, {
                data: {
                  branchId: originalData.branch,
                  userId: data.id,
                },
                headers: { Authorization: `Bearer ${accessToken}` },
              });
            } catch (error) {
              message.error(
                "Failed to remove patient from the original branch"
              );
              console.error("Error deleting branch:", error);
              return; // Stop execution if delete fails
            }
          }

          // Add to new branch
          await axios.post(
            `${API_URL}Branches/addOnePatient`,
            {
              branchId: formValues.branch,
              userId: data.id,
            },
            {
              headers: { Authorization: `Bearer ${accessToken}` },
            }
          );

          message.success("Pharmacy branch updated successfully");
        }
      } catch (error) {
        message.error("Failed to update pharmacy branch");
        console.error("Error updating branch:", error);
      }

      delete changedData.pharmacy;
      delete changedData.branch;

      if (imageUrl) changedData.profilePicture = imageUrl;

      if (Object.keys(changedData).length > 0) {
        await axios.patch(
          `${API_URL}UserProfiles/?id=${data.id}`,
          changedData,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );

        // Update local state with new values
        setLocalUserDetails(prev => ({
          ...prev,
          ...changedData
        }));

        message.success("Profile updated successfully");
      } else if (!branchChanged) {
        message.info("No changes to save");
      }
    } catch (error) {
      console.error("Error updating:", error);
      message.error(error.response?.data?.message || "Update failed");
    } finally {
      setIsEditing(false);
      setImageUrl("");
    }
  };

  return (
    <>
      <PopUp
        visible={isModalVisible}
        onClose={handleCloseModal}
        UserID={data ? data.id : null}
        setFlagFetch={setFlagFetch}
      />
      <div className="flex space-x-10">
        <div className="flex flex-col bg-white p-10 rounded space-y-6 w-[35%]">
          <div className="flex flex-col items-center space-y-5">
            <UploadProfilePicture
              disabled={!isEditing}
              value={imageUrl ? imageUrl : data ? data.userDetails?.profilePicture : null}
              onChange={(url) => {
                setImageUrl(url);
              }}
            />
          </div>
          <div className="flex flex-col items-center">
            <Form
              form={form}
              layout="vertical"
              onFinish={handleSaveClick}
              style={{ width: "100%" }}
              initialValues={{
                firstName: localUserDetails?.firstName,
                lastName: localUserDetails?.lastName,
                contactNumber: data?.mobileNumber,
                gender: localUserDetails?.gender,
                dob: localUserDetails?.dob && localUserDetails.dob !== "null" ? dayjs(localUserDetails?.dob) : null,
                Weight: localUserDetails?.Weight,
                Height: localUserDetails?.Height,
                medicalHistory: localUserDetails?.medicalHistory,
                allergies: localUserDetails?.allergies,
              }}
            >
              <div className="mb-5 flex flex-row justify-center">
                <Button
                  type="button"
                  icon={
                    <img
                      src="/assets/images/edit-2.svg"
                      alt="edit-icon"
                      style={{
                        width: "16px",
                        filter: isEditing ? "invert(1) brightness(3)" : "none",
                      }}
                    />
                  }
                  style={{
                    background: isEditing ? "#3371EB" : "white",
                    color: isEditing ? "white" : "#A9A9A9",
                    fontWeight: "400",
                    fontSize: "12px",
                    border: "1px solid",
                  }}
                  onClick={isEditing ? handleSaveClick : handleEditClick} // Toggle between Edit and Save
                >
                  {isEditing ? "Save" : "Edit Profile"}
                </Button>
              </div>
              <Form.Item
                label="Patient First Name"
                name="firstName"
                style={{ fontWeight: "500", fontSize: "16px" }}
              >
                <Input disabled={!isEditing} />
              </Form.Item>
              <Form.Item
                label="Patient Last Name"
                name="lastName"
                style={{ fontWeight: "500", fontSize: "16px" }}
              >
                <Input disabled={!isEditing} />
              </Form.Item>

              <Form.Item
                label="Contact Number"
                name="contactNumber"
                style={{ fontWeight: "500", fontSize: "16px" }}
              >
                <Input
                  className="no-arrows"
                  style={{ width: "100%" }}
                  disabled={true}
                />
              </Form.Item>
              <div className="flex flex-row space-x-5">
                <Form.Item
                  label="Gender"
                  name="gender"
                  style={{ fontWeight: "500", fontSize: "16px", flex: "1" }}
                >
                  <Select disabled={!isEditing}>
                    <Select.Option value="male">Male</Select.Option>
                    <Select.Option value="female">Female</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Date of birth"
                  name="dob"
                  style={{ fontWeight: "500", fontSize: "16px", flex: "1" }}
                >
                  <DatePicker
                    prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
                    suffixIcon={null}
                    placeholder="Select date"
                    style={{ width: "100%" }}
                    disabled={!isEditing || (localUserDetails?.dob && localUserDetails.dob !== "null")}
                    format={"DD / MM / YYYY"}
                    onChange={(date) => console.log("Selected date:", date)}
                  />
                </Form.Item>
              </div>
              <div className="flex flex-row space-x-5">
                <Form.Item
                  label="Weight"
                  name="Weight"
                  style={{ fontWeight: "500", fontSize: "16px", flex: "1" }}
                >
                  <InputNumber
                    className="no-arrows"
                    style={{ width: "100%" }}
                    disabled={!isEditing}
                    addonAfter={"kg"}
                  />
                </Form.Item>
                <Form.Item
                  label="Height"
                  name="Height"
                  style={{ fontWeight: "500", fontSize: "16px", flex: "1" }}
                >
                  <InputNumber
                    className="no-arrows"
                    style={{ width: "100%" }}
                    disabled={!isEditing}
                    addonAfter={"cm"}
                  />
                </Form.Item>
              </div>
              <div className="flex flex-row space-x-5">
                <Form.Item
                  label={
                    <p
                      style={{
                        color: "#232323",
                        fontWeight: 500,
                        fontSize: "16px",
                      }}
                    >
                      Pharmacy
                    </p>
                  }
                  name="pharmacy"
                  style={{ flex: 1 }}
                >
                  <Select
                    disabled={!isEditing}
                    style={{ height: "40px" }}
                    onChange={handlePharmacyChange}
                  >
                    {pharmacyList.map((pharmacy) => (
                      <Select.Option key={pharmacy.id} value={pharmacy.id}>
                        {pharmacy.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label={
                    <p
                      style={{
                        color: "#232323",
                        fontWeight: 500,
                        fontSize: "16px",
                      }}
                    >
                      Branch
                    </p>
                  }
                  name="branch"
                  style={{ flex: 1 }}
                >
                  <Select
                    style={{ height: "40px" }}
                    disabled={!isEditing}
                    value={branchId} // Ensure this is controlled if needed
                    onChange={(value) => setBranchId(value)} // Handle branch change if needed
                  >
                    {branchList.length > 0 ? (
                      branchList.map((branch) => (
                        <Select.Option key={branch.id} value={branch.id}>
                          {branch.name}
                        </Select.Option>
                      ))
                    ) : (
                      <Select.Option disabled>
                        No branches available
                      </Select.Option>
                    )}
                  </Select>
                </Form.Item>
              </div>
              <Form.Item
                label="Medical History"
                name="medicalHistory"
                style={{ fontWeight: "500", fontSize: "16px" }}
              >
                <TextArea rows={4} disabled={!isEditing} />
              </Form.Item>
              <Form.Item
                label="Allergies"
                name="allergies"
                style={{ fontWeight: "500", fontSize: "16px" }}
              >
                <TextArea rows={4} disabled={!isEditing} />
              </Form.Item>
            </Form>
          </div>
        </div>
        <div className="w-[65%] justify-between items-center border-b border-gray-200">
          <Tabs
            onChange={handleTabChange}
            activeKey={activeKey}
            className="custom-tabs"
            tabBarStyle={{ borderBottom: "none" }}
            indicator="none"
            items={tabList}
          ></Tabs>
        </div>
      </div>
    </>
  );
}

export default ViewProfile;
